import React from 'react';
import { Form, Switch } from 'antd';

type SwitchInputProps = {
  name: string;
  label: string;
  checked?: boolean;
  required?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
};

export function SwitchInput(props: SwitchInputProps) {
  const handleChange = (checked: boolean) => {
    if (props.onChange) {
      props.onChange(checked);
    }
  };
  return (
    <>
      <Form.Item name={props.name} label={props.label} rules={[{ required: props.required, message: `${props.label} is required` }]}>
        <Switch checked={props.checked} onChange={(checked: boolean) => handleChange(checked)} disabled={props.disabled} />
      </Form.Item>
    </>
  );
}
